<mat-card *ngIf="annotations?.length > 0" appearance="outlined" class="se-block">
    <table class="measure-table">
        <tr>
            <th scope="col">{{ "NAME" | translate }}</th>
            <th scope="col">I</th>
            <th scope="col">II</th>
            <th scope="col">III</th>
            <th scope="col">aVR</th>
            <th scope="col">aVL</th>
            <th scope="col">aVF</th>
            <th scope="col">V1</th>
            <th scope="col">V2</th>
            <th scope="col">V3</th>
            <th scope="col">V4</th>
            <th scope="col">V5</th>
            <th scope="col">V6</th>
            <th scope="col">UdM</th>
        </tr>
        <tr *ngFor="let annotation of annotations">
            <td>{{ annotation.name }}</td>
            <td>{{ annotation.value_I }}</td>
            <td>{{ annotation.value_II }}</td>
            <td>{{ annotation.value_III }}</td>
            <td>{{ annotation.value_aVR }}</td>
            <td>{{ annotation.value_aVL }}</td>
            <td>{{ annotation.value_aVF }}</td>
            <td>{{ annotation.value_V1 }}</td>
            <td>{{ annotation.value_V2 }}</td>
            <td>{{ annotation.value_V3 }}</td>
            <td>{{ annotation.value_V4 }}</td>
            <td>{{ annotation.value_V5 }}</td>
            <td>{{ annotation.value_V6 }}</td>
            <td>{{ annotation.udM }}</td>
        </tr>
    </table>
</mat-card>
